module.exports = __webpack_public_path__ + "img/undraw_Tabs_re_a2bd.efae8dca.svg";